<h4>{{ 'orderRequestingUserDetails.requestingUserDetails' | transloco }}</h4>

<div class="flex-container">
  <span class="flex-item">{{ 'orderRequestingUserDetails.user' | transloco }}</span>
  <a
    class="flex-item-2 link-style"
    [routerLink]="['/corporations', $safeNavigationMigration(order.orderGroup?.corporationID), 'usergroups', order.userGroupID, 'users', order.userID]"
    [attr.aria-label]="'orderRequestingUserDetails.userGroupLink' | transloco">
    {{ orderMetaData.requestingUserFullName ?? '' }} ({{ orderMetaData.requestingUserType ?? '' }} - {{ orderMetaData.requestingUserName ?? '' }})
  </a>
</div>
<div class="flex-container">
  <span class="flex-item">{{ 'common.labels.email2' | transloco }}</span><span class="flex-item-2">{{ orderMetaData.requestingUserEmail ?? '' }}</span>
</div>
<div class="flex-container">
  <span class="flex-item">{{ 'orderRequestingUserDetails.userGroup' | transloco }}</span>
  <a
    class="flex-item-2 link-style"
    [routerLink]="['/corporations', $safeNavigationMigration(order.orderGroup?.corporationID), 'usergroups', order.userGroupID]"
    [attr.aria-label]="'orderRequestingUserDetails.userGroupLink' | transloco">
    {{ orderMetaData.requestingUserGroupName ?? '' }}
  </a>
</div>
<div class="flex-container">
  <span class="flex-item">{{ 'common.labels.corporation2' | transloco }}</span>
  @if (order.orderGroup?.corporationID) {
    <a
      class="flex-item-2 link-style"
      [routerLink]="['/corporations', $safeNavigationMigration(order.orderGroup?.corporationID)]"
      [attr.aria-label]="'orderRequestingUserDetails.corporationLink' | transloco">
      {{ orderMetaData.requestingCorporationName ?? '' }}
    </a>
  }
</div>